import { createFileRoute } from "@tanstack/react-router";
import CadenasFranquicias from "@/pages/CadenasFranquicias";
import { pageHead } from "@/lib/pageHead";

export const Route = createFileRoute("/en/chains-and-franchises")({
  head: () => pageHead("chains", "en", { links: false }),
  component: CadenasFranquicias,
});
